import type { ReactElement } from "react";
import type { CharterParams } from "@playbookai/widget-schemas";
import type { WidgetBodyProps } from "../types.js";

/**
 * Defensive read-only body for the register-only Wave 1 charter kind. The VSM
 * workspace continues to render its feature-owned editor until VSM-owned
 * artifact routes replace that adapter in Wave 3.
 */
export function CharterWidget({
  data,
}: WidgetBodyProps<CharterParams>): ReactElement {
  const problem = data.tags.metric.trim() || "Problem not defined";
  const start = data.scope.startPoint.trim() || "Start not defined";
  const end = data.scope.endPoint.trim() || "End not defined";

  return (
    <section className="grid h-full min-h-0 grid-cols-2 gap-3 overflow-auto p-3 text-sm">
      <Summary label="Problem" value={problem} />
      <Summary label="Scope" value={`${start} → ${end}`} />
      <Summary label="Goals" value={`${data.goals.rows.length} defined`} />
      <Summary
        label="Takt calendar"
        value={`${data.takt.shiftsPerDay ?? "—"} shifts/day · ${data.takt.workingDaysPerWeek ?? "—"} days/week`}
      />
    </section>
  );
}

function Summary({
  label,
  value,
}: {
  label: string;
  value: string;
}): ReactElement {
  return (
    <div className="rounded-md border border-pb-border bg-pb-page p-3">
      <div className="text-dense-1 font-medium text-pb-text-muted">{label}</div>
      <div className="mt-1 text-pb-text">{value}</div>
    </div>
  );
}
